import React from "react";
import {toJS} from 'mobx';
import {observer} from 'mobx-react';
import {withRouter} from 'react-router'

import ListTable from '@components/ListTable/ListTable.jsx';
import giveaway_store, {filter_store, pagination_store} from '@store/Statistic/GiveawayLog/GiveawayLogStore';

@withRouter
@observer
class GiveawayLogListTable extends React.Component {
    constructor(props) {
        super();
    }

    componentWillReceiveProps(props, nextProps) {

    }

    columns = [

        {
            key: 'nick_name',
            sorter: true,
            title: '用户名',
            dataIndex: 'nick_name',
        },
        {
            key: 'pet_name',
            sorter: true,
            title: '昵称',
            dataIndex: 'pet_name',
        },
        {
            key: 'id',
            sorter: true,
            title: '交易号',
            dataIndex: 'id',
        },
        {
            key: 'time',
            sorter: true,
            title: '会员赠送时间',
            dataIndex: 'time',
        },
        {
            key: 'giveType',
            sorter: true,
            title: '类型',
            dataIndex: 'giveType',
        },
        {
            key: 'in_money',
            sorter: true,
            title: '赠送金额',
            dataIndex: 'in_money',
        },
        {
            key: 'out_money',
            sorter: true,
            title: '被赠送金额',
            dataIndex: 'out_money',
        },
        {
            key: 'donation_amount',
            sorter: true,
            title: '平台赠送额',
            dataIndex: 'donation_amount',
        },
        {
            key: 'description',
            sorter: true,
            title: '赠送明细',
            dataIndex: 'description',
        },
    ];

    componentWillMount() {

    }

    componentDidMount() {
        giveaway_store.reloadDatas();
    }

    componentWillUnmount() {
        filter_store.resetAttr();
    }

    //点击搜索回调
    closeAllExpandedForReload = () => {

    }

    pagination_callback(page, size, order_by) {
        giveaway_store.searchByFilter({
            page: page,
            page_size: size,
            ...order_by,
        })
    }

    render() {
        return (
            <ListTable
                data_source={toJS(giveaway_store.item_array)}
                columns={this.columns}
                rowClassName='cursor_pointer_all'
                pagination={
                    {
                        current: pagination_store.page_cur,// 当前页
                        page_size: pagination_store.page_size,//每页数
                        total: pagination_store.data_total,//总数据条数
                        pageSizeOptions: pagination_store.page_size_options,//页码候选列表
                    }
                }
                expandedRowRender={
                    this.expandedRowRender
                }
                onChange={
                    (pagination, filters, sorter) => {
                        let current = pagination.current;
                        let page_size = pagination.pageSize;
                        let order_by = undefined;
                        if (sorter.columnKey !== undefined) {
                            let desc = 0;
                            if (sorter.order == 'descend') {
                                desc = 1;
                            }
                            order_by = {
                                order: sorter.columnKey,
                                desc: desc
                            }
                        }
                        this.pagination_callback(current, page_size, order_by);
                    }
                }
                onExpand={(expanded, record) => {

                }
                }
                onExpandedRowsChange={(expandedRows) => {
                    if (expandedRows.length < 2) {
                        this.setState({
                            expandedRowKeys: expandedRows
                        })
                    } else {
                        this.setState({
                            expandedRowKeys: [expandedRows[expandedRows.length - 1]]
                        })
                    }
                }}
                expandRowByClick
            />
        );
    }
}

export default GiveawayLogListTable;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/GiveawayLog/GiveawayLogListTable.jsx